import { Pipe, PipeTransform } from '@angular/core';
import { DateUtilities } from '@approot/utilities';

@Pipe({
  name: 'prettyDate'
})
export class PrettyDatePipe implements PipeTransform {
  transform(value: any): any {
    if (DateUtilities.isDateOfDashedFormat(value)) {
      return DateUtilities.dateToPrettyDate(value);
    } else if (DateUtilities.isDateOfSlashFormat(value)) {
      return DateUtilities.dateToPrettyDate(
        DateUtilities.restructureDate(value)
      );
    }
  }
}
